/* eslint-disable quotes */
// API nativa, sin librerías
// Abre/crea múltiples DB por nombre+versión y corre el upgrade con tu esquema.
const _cache = new Map();

/**
 * openDB('miniGuides', 1, (db, oldVersion, newVersion) => {
 *   if (!db.objectStoreNames.contains('guides')) {
 *     const store = db.createObjectStore('guides', { keyPath: 'id' });
 *     store.createIndex('byCategory', 'category', { unique: false });
 *   }
 * });
 */
export function openDB(dbName, version, onUpgrade) {
  const cacheKey = `${dbName}@${version}`;
  if (_cache.has(cacheKey)) return _cache.get(cacheKey);

  const p = new Promise((resolve, reject) => {
    const req = indexedDB.open(dbName, version);

    req.onupgradeneeded = (ev) => {
      const db = req.result;
      try {
        onUpgrade?.(db, ev.oldVersion, ev.newVersion);
      } catch (e) {
        console.error(`[IndexedDB] upgrade error on ${dbName}`, e);
        reject(e);
      }
    };

    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
    req.onblocked = () => console.warn(`[IndexedDB] "${dbName}" blocked (close other tabs).`);
  });

  _cache.set(cacheKey, p);
  return p;
}

export async function withTx(db, storeNames, mode, fn) {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeNames, mode);
    const stores = Array.isArray(storeNames) ? storeNames.map((n) => tx.objectStore(n)) : [tx.objectStore(storeNames)];

    const done = (val) => {
      // finish when the transaction completes
      tx.oncomplete = () => resolve(val);
    };

    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);

    try {
      const ret = fn(...stores, tx);
      // if fn returns a promise, wait for it and then resolve
      if (ret instanceof Promise) {
        ret.then(done).catch(reject);
      } else {
        done(ret);
      }
    } catch (e) {
      reject(e);
    }
  });
}

// Basic CRUD helpers (for a single store)
export const crud = {
  get(db, store, key) {
    return withTx(db, store, "readonly", (s) => requestToPromise(s.get(key)));
  },
  getAll(db, store) {
    return withTx(db, store, "readonly", (s) => requestToPromise(s.getAll()));
  },
  put(db, store, value) {
    return withTx(db, store, "readwrite", (s) => requestToPromise(s.put(value)));
  },
  bulkPut(db, store, values) {
    return withTx(db, store, "readwrite", async (s) => {
      for (const v of values) await requestToPromise(s.put(v));
    });
  },
  delete(db, store, key) {
    return withTx(db, store, "readwrite", (s) => requestToPromise(s.delete(key)));
  },
  clear(db, store) {
    return withTx(db, store, "readwrite", (s) => requestToPromise(s.clear()));
  },
  byIndex(db, store, indexName, query) {
    return withTx(db, store, "readonly", (s) => requestToPromise(s.index(indexName).getAll(query)));
  },
};

function requestToPromise(req) {
  return new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
